import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-nigeria-pension-feedback.component.scss';
var FormItemNigeriaPensionFeedback = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemNigeriaPensionFeedback, _super);
    function FormItemNigeriaPensionFeedback(element) {
        return _super.call(this, element) || this;
    }
    FormItemNigeriaPensionFeedback.prototype.init = function () {
        this.selectFeedbackType = this.element.querySelector('.js-feedback-request');
        this.selectFeedbackTypeRelated = this.element.querySelector('.js-feedback-related');
    };
    FormItemNigeriaPensionFeedback.prototype.bindEvents = function () {
        var _this = this;
        this.selectFeedbackType.addEventListener('change', function (e) {
            var element = undefined;
            if (e.target) {
                element = e.target;
            }
            _this.populateSelect(element.value);
        });
    };
    FormItemNigeriaPensionFeedback.prototype.populateSelect = function (choice) {
        if (choice === void 0) { choice = ""; }
        var requests = [
            'Please select',
            'Outstanding contributions complaints',
            'Benefit Application Complaints',
            'Data Recapture',
            'General Complaints',
            'Accrued Right',
            'Contribution Remittance',
            'Account Statement Request',
            'Wrong clients details',
            'Poor Services',
            'Others',
            'SMS not received',
        ];
        var complaints = [
            'Please select',
            'Retirement/Withdrawal enquiries',
            'Account Statement Request',
            'General Enquiries',
            'Update on application submitted',
            'Remittance Enquiries',
            'Benefit Application Enquiries',
            'Change/Update of client details',
            'Data Recapture',
            'Embassy Letter request',
            'Change of Date of Birth',
            'Others',
        ];
        if (choice === 'REQUEST') {
            var output_1 = "";
            requests.map(function (request) {
                if (request === 'Please select') {
                    output_1 += "<option value=\"\">" + request + "</option>";
                }
                else {
                    output_1 += "<option value=\"" + request + "\">" + request + "</option>";
                }
            });
            this.selectFeedbackTypeRelated.innerHTML = output_1;
        }
        else {
            var output_2 = "";
            complaints.map(function (complaint) {
                if (complaint === 'Please select') {
                    output_2 += "<option value=\"\">" + complaint + "</option>";
                }
                else {
                    output_2 += "<option value=\"" + complaint + "\">" + complaint + "</option>";
                }
            });
            this.selectFeedbackTypeRelated.innerHTML = output_2;
        }
    };
    return FormItemNigeriaPensionFeedback;
}(Base));
export { FormItemNigeriaPensionFeedback };



//////////////////
// WEBPACK FOOTER
// ./components-nigeria/form-item-nigeria-pension-feedback/form-item-nigeria-pension-feedback.component.ts
// module id = 638
// module chunks = 0